import { Component, Inject, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@src/store';
import { projectActions } from "../../../../../../store/reducers/projectReducer";
import { DialogManagerService } from '@src/services';
import { consts } from '@src/constants/consts';
import { databasesActions } from '../../../../../../store/reducers/databasesReducer';
import lodash from 'lodash';
import $ from 'jquery';


@Component({
    selector: 'schemas-env-type-rotate-item',
    template: require('./rotatorItem.html'),
    styles: [require('./_rotatorItem.scss')]
})

export class EnvTypeRotateItemComponent implements OnInit, OnDestroy {
    public prevEnvironmentType: any
    @Input() public projectData;

    @Input() public set currEnvTypeIndex(value) {
        this._currEnvTypeIndex = value;
        const rmSourceEnvType = this.selectedEnvTypes.filter((item) => item.isRMSource === true)[0];
        const rmSourceIndex = this.selectedEnvTypes.indexOf(rmSourceEnvType);
        this.prevEnvironmentType = this.selectedEnvTypes.indexOf(this.currEnvironmentType) != rmSourceIndex ? rmSourceEnvType : null;
    }
    @Input() set currEnvironmentType(value) {
        this._currEnvironmentType = value;
        let rmSourceEnvType = this.selectedEnvTypes.filter((item) => item.isRMSource == true)[0];
        let rmSourceIndex = this.selectedEnvTypes.indexOf(rmSourceEnvType);
        if (this.selectedEnvTypes.indexOf(value) != rmSourceIndex) {
            this.prevEnvironmentType = rmSourceEnvType;
        } else {
            this.prevEnvironmentType = null;
        }
        this.selectedEnvTypes.forEach((item, index) => {
            item.environments.forEach((env) => {
                env.IsHybrid = index > rmSourceIndex ? 1 : index < rmSourceIndex ? -1 : 0;
            });
        });

        if (this.projectData) {
            let rmEnv = this.projectData.environmentTypes.filter(env => env.isRMSource)[0].environments[0].schemas;
            if (rmEnv) {
                this.rmsourceSchemas = rmEnv.map(schema => {
                    return { "scheamId": schema.schemaId, "tempSchemaId": schema.tempSchemaId, "isSuperUser": schema.isSuperUser };
                });
            }
        }
        // this.envSelected(
        //     this.currEnvironmentType ? (this.currEnvironmentType.environments.find(env => {
        //         return env.envSelected;
        //     }) ?
        //         this.currEnvironmentType.environments.find(env => {
        //             return env.envSelected;
        //         }) :
        //         this.currEnvironmentType.environments[0]) : (this.store.getState().project.environmentTypes.find(env => {
        //         return env.envSelected;
        //     }) ?
        //         this.store.getState().project.environmentTypes.find(env => {
        //             return env.envSelected;
        //         }) :
        //         this.store.getState().project.environmentTypes[0]))
        // ;
    }
    @Output() onClose = new EventEmitter<any>();

    public _currEnvTypeIndex: any
    public nextEnvironmentType: any
    public schemasRepository: any
    public unsubscribe: any
    public isRMmustBeManage: any
    public backDeletedScheamToList = [];
    public rmsourceSchemas: any
    public _currEnvironmentType: any
    public selectedEnvironment: any
    public canRotateLeft: any
    public isUpdate: any;
    public databaseType: any
    public canRotateRight: boolean
    public scheamSuperUser: any
    public dataT: any;
    public isMassegeDisplayed: boolean = false;
    public $translate;


    constructor(@Inject('$filter') public $filter: any, private dialogManagerService: DialogManagerService, @Inject('$scope') public $scope: any, public store: Store, @Inject('$state') public state: any, @Inject('$stateParams') public $stateParams: any) {
        this.dataT = this.$filter('dbTypeItem')(["Schemas"], this.state.params.dbType)
        this.$translate = $filter('translate');
    }

    ngOnInit() {
        this.superUser = (item) => {
            if (item.isSuperUser == true)
                this.scheamSuperUser = item;
            return item.isSuperUser == false
        };

        this.databaseType = this.state.params.dbType;
        this.$scope.$watchCollection(() => this.store.getState().project.availableSchemas, (newVal) => {
            if (newVal == null) {
                return;
            }
            this.selectedEnvTypes.forEach(envType => {
                envType.environments.forEach(env => {
                    let oldVal = newVal;
                    newVal = lodash.differenceBy(newVal, env.schemas, 'dbId');
                    if (oldVal.length != newVal.length) {
                        this.isUpdate = true;
                    }
                    this.isUpdate = true;
                });
            });
            if (this.isUpdate) {
                if (!this.store.getState().project.dbId || this.store.getState().project.dbId == this.databaseType) {
                    this.schemasRepository = newVal;
                    this.isUpdate = false;
                }
            }
        });


        this.$scope.$watchCollection(() => this.store.getState().project.schemas, (newVal) => {
            if (newVal == null || newVal.length == 0)
                return;
            if (!this.schemasRepository) {
                this.schemasRepository = [];
            }
            newVal.forEach(item => {
                item.connectionProperties.serverKey = item.connectionProperties.host + item.connectionProperties.port;
                this.schemasRepository = [...this.schemasRepository, item];
            });
            this.selectedEnvTypes.forEach(envType => {
                envType.environments.forEach(env => {
                    let oldVal = newVal;
                    let filterBySameHost = (!env.schemas) ? env.schemas : env.schemas.filter(obj => {
                        obj.connectionProperties.serverKey == newVal[0].connectionProperties.serverKey && obj.connectionProperties.identifier == newVal[0].connectionProperties.identifier
                    });
                    newVal = lodash.differenceBy(newVal, filterBySameHost, 'schemaName');
                    if (oldVal.length != newVal.length) {
                        this.isUpdate = true;
                    }
                    this.isUpdate = true;
                });
            });
            if (this.isUpdate) {
                this.isUpdate = false;
                this.schemasRepository = newVal;
                this.isUpdate = false;
            }
            if (this.schemasRepository != null)
                this.schemasRepository.forEach((i) => i.selected = false);
        });
    }

    superUser = (item) => {
        if (item.isSuperUser == true)
            this.scheamSuperUser = item;
        return item.isSuperUser == false
    };

    assignSchemasToEnvironment(environment, schemas) {
        if (this.selectedEnvTypes[this._currEnvTypeIndex].quantity <= 0) {
            this.dialogManagerService.showErrorDialog({
                title: this.$translate('ERROR'),
                text: this.$translate('ERROR_ENVIROMNET_NOT_SELCET')
            });
            return;
        }
        if (!environment?.isRMSource && (schemas?.length + environment?.schemas?.length) > this.rmsourceSchemas?.length) {
            this.dialogManagerService.showErrorDialog({
                title: this.$translate('ERROR'),
                text: this.$translate('ERROR_ENVIRONMENT_MAX_REACHED')
            });
            return;
            //schemas = schemas.slice(0, this.rmsourceSchemas?.length);
        }
        var isValid = true;
        var invalidSchemasList = [];
        if (this.databaseType == undefined) {
            this.databaseType = this.projectData.dbTypeId
        }
        if (environment?.isRMSource || environment?.isTest || environment?.envTypeId === consts?.envTypes?.PreRun) {
            this.store.dispatch({
                type: projectActions.IS_RM_MANAGE_BY_DBTYPE,
                payload: { dbTypeId: this.databaseType }
            }).then(res => {
                this.isRMmustBeManage = res
                if (environment?.isTest || environment?.envTypeId == consts?.envTypes?.PreRun) {
                    for (var i = 0; i < schemas.length; i++) {
                        let schema = schemas[i];
                        if (schema.isManaged == true) {
                            isValid = false;
                            invalidSchemasList.push(schema.schemaName)
                        }
                    }
                } else if (this.isRMmustBeManage) {
                    for (var i = 0; i < schemas.length; i++) {
                        let schema = schemas[i];
                        if (schema.isManaged == false) {
                            isValid = false;
                            invalidSchemasList.push(schema.schemaName)
                        }
                    }
                }

                let isNotAssigned;
                schemas?.forEach(schema => {
                    if (!schema.isAssigned)
                        isNotAssigned = true;
                })
                if (isNotAssigned && environment.hasVersion && schemas.length > 0) {
                    //create the schemasNames in a pattern of ('schemaName' , 'schemaName2')
                    if (this.isMassegeDisplayed) {
                        this.assignSchemas(environment, schemas, isValid, invalidSchemasList)
                        return
                    }
                    let schemasNames = "(";
                    schemas?.forEach(schema => {
                        if (!schema.isAssigned)
                            schemasNames += '\'' + schema.dbName + '\' , ';
                    });
                    schemasNames = schemasNames.slice(0, -3);
                    schemasNames += ")";

                    let schemaOrDatabase = "";
                    let headerSchemaOrDatabase = "";
                    if (this.projectData && this.projectData.dbTypeId == 3) {
                        headerSchemaOrDatabase = "Schema";
                        schemaOrDatabase = "schema";
                    } else if (this.projectData && this.projectData.dbTypeId != 3) {
                        headerSchemaOrDatabase = "Database";
                        schemaOrDatabase = "database";
                    }

                    const onConfirm = () => {
                        this.isMassegeDisplayed = true;
                        this.assignSchemas(environment, schemas, isValid, invalidSchemasList)
                    };
                    const dialogData = {
                        title: this.$translate('ADD_SCHEMA_OR_DATBASE_TO_RS_HEADER').replace("%schemaOrDatabase", headerSchemaOrDatabase),
                        action: null,
                        message: this.$translate('CONFIRM_ADDING_SCHEMA_OR_DATABASE_FROM_RS')
                            .replace("%(schemaOrDatabase)", schemaOrDatabase)
                            .replace("%(schemasNames)", schemasNames)
                    };
                    this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);

                } else {
                    this.assignSchemas(environment, schemas, isValid, invalidSchemasList)
                }
            });
        } else {
            this.assignSchemas(environment, schemas, isValid, invalidSchemasList)
        }
    }

    OnClose() {
        this.onClose.emit()
    }

    assignSchemas(environment, schemas, isValid, invalidSchemasList) {
        if (isValid === false) {
            let errorMessage = (!environment.isTest && environment.envTypeId !== consts.envTypes.PreRun) ? this.$translate('ERROR_ENVIROMNET_RS') : this.$translate('ERROR_ENVIROMNET_TEST')
            this.dialogManagerService.showErrorDialog({
                title: this.$translate('ERROR'),
                text: errorMessage.replace("%s", invalidSchemasList.join())
            });
            return;
        }

        if (environment && schemas) {
            if (environment.isRMSource == false) {
                if (environment.schemas4UIView) {
                    schemas.forEach((schema2Add) => {
                        var targetIndex = -1;
                        //push the new schema into the array where the first "id==-1" (this is the first placeholder)
                        environment.schemas4UIView.forEach((schema, index) => {
                            if (targetIndex == -1 && schema.id == -1) {
                                targetIndex = index;
                            }
                        });
                        if (targetIndex != -1) {
                            environment.schemas4UIView[targetIndex] = schema2Add;
                            if (environment.schemas == null)
                                environment.schemas = [];
                            environment.schemas.splice(targetIndex, 0, schema2Add);
                            //schema2Add.isAssigned = true;
                        }
                        //Add the new schema at the end of the list
                        //schemas.forEach(schema => {
                        //    environment.schemas = [...environment.schemas, schema];
                        //});
                    });
                } else {
                    environment.schemas = schemas;
                    environment.schemas4UIView = schemas.filter(s => !s.isSuperUser);
                }
            }
            else {
                if (environment.schemas == null)
                    environment.schemas = [];
                //Add the new schema at the end of the list
                schemas.forEach(schema => {
                    // Check if this exact schema already exists (same schemaId AND tempSchemaId)
                    // Only prevent true duplicates - allow re-adding if tempSchemaId differs
                    const existingIndex = environment.schemas.findIndex(s =>
                        s.schemaId && s.schemaId === schema.schemaId &&
                        s.tempSchemaId && s.tempSchemaId === schema.tempSchemaId
                    );

                    if (existingIndex === -1) {
                        // Schema doesn't exist with these exact IDs, add it
                        environment.schemas = [...environment.schemas, schema];
                        //schema.isAssigned = true;
                    }
                    // If exact match exists, don't add duplicate

                });
                environment.schemas4UIView = environment.schemas.filter(s => !s.isSuperUser);
            }

            //remove added schemas to select from repository list for selection
            environment.schemas.forEach(schema => {
                lodash.remove(this.schemasRepository, {
                    schemaId: schema.schemaId,
                    tempSchemaId: schema.tempSchemaId
                });
            });

            let rmSourceEnv = this.selectedEnvTypes.filter((item) => item.isRMSource == true)[0].environments[0];
            var superS = rmSourceEnv.schemas.filter(item => item.isSuperUser)[0];
            rmSourceEnv.schemas = rmSourceEnv.schemas.filter(item => !item.isSuperUser);
            if (rmSourceEnv != null && (rmSourceEnv.envTypeId != environment.envTypeId || rmSourceEnv.tempEnvId != environment.tempEnvId) && rmSourceEnv.schemas != null) {
                var superSofEnv = environment.schemas.filter(item => item.isSuperUser)[0];
                if (superSofEnv)
                    environment.schemas = environment.schemas.filter(item => !item.isSuperUser);
                //TODO: Consider changing this logic and just calling the SetOrder function instead
                //Here we set the mapping of the newluy added schemas
                environment.schemas.forEach((schema, index) => {
                    if (index < rmSourceEnv.schemas.length) {
                        let relativeRMSourceSchema = rmSourceEnv.schemas[index];
                        if (!schema.isSuperUser) {
                            schema.schemaMap = {
                                envId: rmSourceEnv.id,
                                tempEnvId: rmSourceEnv.tempEnvId,
                                schemaId: relativeRMSourceSchema.schemaId,
                                tempSchemaId: relativeRMSourceSchema.tempSchemaId
                            }
                        }
                    }
                })
                if (superSofEnv)
                    environment.schemas.push(superSofEnv);
            }
            if (superS)
                rmSourceEnv.schemas.push(superS);
            //update other schema's envs (on other types) if new schema rm is added.
            if (this.store.getState().project.editMode && this.selectedEnvTypes[this._currEnvTypeIndex].isRMSource) {
                let relevantTypes = this.projectData.environmentTypes.filter(env => !env.isRMSource && env.environments.length > 0)
                if (relevantTypes)
                    relevantTypes.forEach(type => {
                        type.environments.forEach(env => {
                            if (env.schemas)
                                var superUserSchema = env.schemas.filter(s => s.isSuperUser)[0];
                            if (superUserSchema) {
                                superUserSchema.schemaMap = null;
                                env.schemas = env.schemas.filter(s => !s.isSuperUser);
                            }
                            env.schemas.forEach((item, index) => {
                                if (!item.isSuperUser) {
                                    if (!item.schemaMap) {
                                        let relativeRMSourceSchema = rmSourceEnv.schemas[index];
                                        item.schemaMap = {
                                            envId: rmSourceEnv.id,
                                            tempEnvId: rmSourceEnv.tempEnvId,
                                            schemaId: relativeRMSourceSchema.schemaId,
                                            tempSchemaId: relativeRMSourceSchema.tempSchemaId
                                        }
                                    } else {
                                        if (item.schemaMap.envId == 0) {
                                            if (environment.schemas[index]) {
                                                item.schemaMap.tempSchemaId = environment.schemas[index].tempSchemaId
                                                item.schemaMap.schemaId = (environment.schemas[index].schemaId) ? environment.schemas[index].schemaId : 0
                                            }
                                        } else {
                                            if (environment.schemas[index]) {
                                                item.schemaMap.schemaId = environment.schemas[index].schemaId
                                                item.schemaMap.tempSchemaId = environment.schemas[index].tempSchemaId
                                            }
                                        }
                                    }
                                }
                            })
                            if (superUserSchema)
                                env.schemas.push(superUserSchema);
                        });
                    });
            }
        }
    }


    removeSchema(environment, schema) {
        let hasAssignError = false;
        if (environment.isRMSource) {
            //check if removing the scehma in RS will not cause that other envs will have less schemas than the RS
            let relevantTypes = this.projectData.environmentTypes.filter(env => !env.isRMSource && env.environments.length > 0)
            if (relevantTypes)
                relevantTypes.forEach(type => {
                    type.environments.forEach(env => {
                        if (env.schemas && env.schemas.filter(schema => !schema.isSuperUser).length === environment.schemas.filter(schema => !schema.isSuperUser).length) {
                            hasAssignError = true;
                        }
                    })
                });
            if (hasAssignError) {
                this.dialogManagerService.showErrorDialog({
                    title: this.$translate('ERROR'),
                    text: 'The selected schema was not removed. This schema connected to schema in other environment(s).'
                });
                return;
            }
            if (schema.isAssigned && schema) {
                let schemaOrDatabase = "";
                let headerSchemaOrDatabase = "";
                if (this.projectData && this.projectData.dbTypeId === 3) {
                    headerSchemaOrDatabase = "Schema";
                    schemaOrDatabase = "schema";
                } else if (this.projectData && this.projectData.dbTypeId !== 3) {
                    headerSchemaOrDatabase = "Database";
                    schemaOrDatabase = "database";
                }

                const onConfirm = () => {
                    this.removeSchemaDetails(environment, schema);
                };
                const dialogData = {
                    title: this.$translate('REMOVE_SCHEMA_OR_DATBASE_FROM_RS_HEADER').replace("%schemaOrDatabase", headerSchemaOrDatabase),
                    action: null,
                    message: this.$translate('CONFIRM_REOMVE_SCHEMA_OR_DATABASE_FROM_RS')
                        .replaceAll("%(schemaOrDatabase)", schemaOrDatabase)
                        .replace("%(schemasNames)", schema.name)
                };
                this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);

            } else if (environment.isManaged || !schema.isAssigned && schema) {
                this.removeSchemaDetails(environment, schema)
            }
        } else if (!hasAssignError)
            this.removeSchemaDetails(environment, schema);
    }

    RemoveSchema(data) {
        this.removeSchema(data.environment, data.schema);
        //this.removeSchemaDetails(data.environment , data.schema);
    }

    //Remove schema from the UI on envs other than RS
    removeSchemaDetails(environment, schema) {
        if (environment && schema) {
            let foundSchema = lodash.find(environment.schemas, {
                schemaId: schema.schemaId,
                tempSchemaId: schema.tempSchemaId
            });
            if (foundSchema) {
                foundSchema.selected = false;
                if (this.schemasRepository && this.schemasRepository.length > 0 && this.schemasRepository[0].connectionProperties.serverKey == foundSchema.connectionProperties.serverKey && foundSchema.isManaged == this.schemasRepository[0].isManaged
                    || this.schemasRepository && this.schemasRepository.length > 0 && this.schemasRepository[0].isManaged == true && foundSchema.isManaged == true) {
                    let obj = lodash.find(this.schemasRepository, item => {
                        return item.schemaName == foundSchema.schemaName
                    })
                    if (!obj)
                        this.schemasRepository = [...this.schemasRepository, foundSchema];
                } else if ((!this.schemasRepository || this.schemasRepository.length == 0) && foundSchema.isManaged == true) {
                    this.schemasRepository = [];
                    this.schemasRepository = [...this.schemasRepository, foundSchema];

                    this.store.dispatch({
                        type: projectActions.GET_AVAILABLE_SCHEMAS,
                        payload: { project: this.projectData, dbID: this.databaseType }
                    })
                        .then((resp) => resp, () => {
                        });
                } else {
                    this.backDeletedScheamToList.push(foundSchema);
                }

                //this.markSchemaIdNoneInArray(environment.schemas, schema.schemaId);
                lodash.remove(environment.schemas, { schemaId: schema.schemaId, tempSchemaId: schema.tempSchemaId });

                // CRITICAL FIX: Regenerate schemas4UIView after removal to update the UI immediately
                environment.schemas4UIView = environment.schemas ? environment.schemas.filter(s => !s.isSuperUser) : [];

                //TODO: Need to update schemas4UIView list in _environment
                if (environment.schemas && environment.schemas.length === 0) {
                    environment.schemas = null;
                    environment.schemas4UIView = [];
                }
                if (this.store.getState().project.editMode && environment.isRMSource && environment.schemas) {
                    let relevantTypes = this.projectData.environmentTypes.filter(env => !env.isRMSource && env.environments.length > 0)
                    if (relevantTypes)
                        relevantTypes.forEach(type => {
                            type.environments.forEach(env => {
                                if (env.schemas) {
                                    var superUserSchemaOfEnv = env.schemas.filter(s => s.isSuperUser)[0];
                                    env.schemas = env.schemas.filter(s => !s.isSuperUser);
                                    env.schemas.forEach((item, index) => {
                                        item.schemaMap.schemaId = environment.schemas[index]?.schemaId
                                        item.schemaMap.tempSchemaId = environment.schemas[index]?.tempSchemaId
                                    });
                                }
                                if (superUserSchemaOfEnv)
                                    env.schemas.push(superUserSchemaOfEnv);
                            })
                        });
                } else if (this.store.getState().project.editMode && environment.schemas) {
                    let rsEnv = this.projectData.environmentTypes.filter(env => env.isRMSource && env.environments.length > 0)
                    if (rsEnv) {
                        rsEnv.forEach(type => {
                            type.environments.forEach(env => {
                                var superUserSchemaOfRM = env.schemas.filter(s => s.isSuperUser)[0];
                                var superUserSchemaOfEnv = environment.schemas.filter(s => s.isSuperUser)[0];
                                if (superUserSchemaOfRM) {
                                    env.schemas = env.schemas.filter(s => !s.isSuperUser);
                                }
                                if (superUserSchemaOfEnv) {
                                    environment.schemas = environment.schemas.filter(s => !s.isSuperUser);
                                }
                                if (env.schemas)
                                    env.schemas.forEach((item, index) => {
                                        if (environment.schemas[index]) {
                                            if (!environment.schemas[index].schemaMap) {
                                                environment.schemas[index].schemaMap = {};
                                            }
                                            item = item;
                                            //environment.schemas[index].schemaMap.envId = item.envId;
                                            //environment.schemas[index].schemaMap.schemaId = item.schemaId;
                                            //environment.schemas[index].schemaMap.tempSchemaId = item.tempSchemaId;
                                        }
                                    })
                                if (superUserSchemaOfRM)
                                    env.schemas.push(superUserSchemaOfRM);
                                if (superUserSchemaOfEnv)
                                    environment.schemas.push(superUserSchemaOfEnv);
                            });
                        });
                    }
                }
            }
        }
    }

    markSchemaIdNoneInArray(schemas, schema2Remove) {
        schemas.forEach((schema, index) => {
            if ((schema.id != null && schema.id != -1 && schema.id != 0 && schema.id == schema2Remove.id)
                || (schema.tempSchemaId != null && schema.tempSchemaId != -1 && schema.tempSchemaId == schema2Remove.tempSchemaId)) {
                schemas[index].schemaMap = {};
                //schemas[index].id = -1;
                //schemas[index].schemaId = -1;
                //schemas[index].tempSchemaId = null;
            }
        });
    }

    replaceSchemaOfRm(environment, data) {
        var superUserFlag = false
        if (environment.schemas) {
            var superUser = environment.schemas.filter(item => item.isSuperUser == true)[0];
            if (superUser) {
                environment.schemas = environment.schemas.filter(item => item.isSuperUser == false)
                superUserFlag = true;
            }
            environment.schemas = lodash.uniqBy(environment.schemas, function (elem) {
                return [elem.schemaId, elem.tempSchemaId].join();
            });
        }
        environment.schemas.forEach((schema, index) => {
            if (data.source && data.source[index]) {
                if (!schema.schemaMap)
                    schema.schemaMap = {};
                schema.schemaMap.schemaId = data.source[index].schemaId;
                if (data.source[index].envId)
                    schema.schemaMap.envId = data.source[index].envId;
                if (data.source[index].tempSchemaId) {
                    schema.schemaMap.tempSchemaId = data.source[index].tempSchemaId;
                }
            }
        });
        if (superUserFlag)
            environment.schemas.push(superUser);
        else if (this.scheamSuperUser)
            environment.schemas.push(this.scheamSuperUser);
    }

    changeHost(hostselected, unmangeSchemasByHostList) {
        if (this.backDeletedScheamToList.length > 0) {
            this.backDeletedScheamToList.forEach(item => {
                unmangeSchemasByHostList.forEach(obj => {
                    if (obj && obj.length > 0) {
                        if (item.connectionProperties.serverKey == obj[0].connectionProperties.serverKey || (item.isManaged == true && obj[0].isManaged == true))
                            obj.push(item);
                    }
                })
            })
            this.backDeletedScheamToList = [];
        }
        if (unmangeSchemasByHostList.length > 0) {
            if (hostselected.isManaged) {
                var temp = unmangeSchemasByHostList.filter(item => item.length > 0 && item[0].isManaged == true); // managed schemas on all hosts
                if (temp && temp.length > 1)
                    this.schemasRepository = temp.find(item => item[0].connectionProperties && item[0].connectionProperties.serverKey == hostselected.connectionProperties.serverKey)
                else this.schemasRepository = (temp[0]) ? temp[0] : [];
            } else {
                var result = unmangeSchemasByHostList.find(item => item.length > 0 && item[0].connectionProperties && item[0].connectionProperties.serverKey == hostselected.connectionProperties.serverKey && item[0].isManaged == false)
                this.schemasRepository = result;
            }
        }
    }

    addEnvironment() {
        this.unsubscribe = this.store.subscribe(() => {
            if (this.store.getState().project.data.environmentTypes[this._currEnvTypeIndex]) {
                let index = this.selectedEnvTypes[this._currEnvTypeIndex].quantity - 1;
                let newEnv = this.store.getState().project.data.environmentTypes[this._currEnvTypeIndex].environments[index];
                this.selectedEnvironment = newEnv;
                this.unsubscribe();
                setTimeout(() => {
                    $("div.environment-item-scroller > div.schema-env-minified:last-child > div").click();
                }, 50);
            }
        });
        this.selectedEnvTypes[this._currEnvTypeIndex].quantity += 1;
        this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: this.projectData } });
    }

    removeEnvironment(data) {

        this.projectData.environmentTypes[data.env.envTypeId].environments = this.projectData.environmentTypes[data.env.envTypeId].environments.filter(env => env.id != data.env.id);
        this.selectedEnvTypes[this._currEnvTypeIndex].quantity -= 1;
        if (this.selectedEnvTypes[this._currEnvTypeIndex].quantity >= 0) {
            this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: this.projectData } });

            this.store.dispatch({
                type: projectActions.GET_AVAILABLE_SCHEMAS,
                payload: { project: this.projectData, dbID: this.databaseType }
            }).then((resp) => {
                // update envs map  by new env id of rm
                if (this.store.getState().project.editMode && this.selectedEnvTypes[this._currEnvTypeIndex].isRMSource) {
                    setTimeout(() => {
                        $("div.environment-item-scroller > div.schema-env-minified:last-child > div").click();
                    }, 50);
                    let relevantTypes = this.projectData.environmentTypes.filter(env => !env.isRMSource && env.environments.length > 0)
                    if (relevantTypes)
                        relevantTypes.forEach(type => {
                            type.environments.forEach(env => {
                                if (env.schemas)
                                    env.schemas.forEach((item) => {
                                        if (!item.isSuperUser) {
                                            item.schemaMap.envId = 0;
                                            item.schemaMap.tempEnvId = this.selectedEnvTypes[this._currEnvTypeIndex].environments[0].tempEnvId;
                                        }
                                    });
                            })
                        });
                }
                return resp;
            }, () => {
            });
        }
    }

    addUnamanagedSchemas(environment, connectionProps) {
        let payload = {
            environmentId: 0,
            environmentTempId: 0,
            project: this.projectData,
            connectionProperties: connectionProps.connectionProperties.connectionProperties
        };
        if (environment) {
            payload.environmentId = environment.id;
            payload.environmentTempId = environment.tempEnvId;
        }
        if (connectionProps.isTest) {
            this.store.dispatch({ type: databasesActions.RESET_SCHEMAS_TEST_CONNECT_STATUS });
            this.store.dispatch({ type: databasesActions.TEST_CONNECT, payload: payload }).then(testStatus => {
                if (testStatus) { }
                if (this.store.getState().schemas.status_test_schema) {
                    connectionProps.connectionProperties.status_test_schema = this.store.getState().schemas.status_test_schema;
                    delete this.store.getState().schemas.status_test_schema;
                }
            });
        } else {
            this.store.dispatch({ type: projectActions.ADD_UNAMANGED_SCHEMAS, payload: payload });

        }
    }



    get currEnvironmentType() {
        return this._currEnvironmentType;
    }

    saveSchemaSettings() {
    }

    envSelected(env) {
        this.selectedEnvironment = env;
    }

    get selectedEnvTypes() {
        return this.projectData
            ? this.projectData.environmentTypes.filter(item => item.selected)
            : [];
    }

    checkingConnector($index) {
        if (this.selectedEnvironment && this.prevEnvironmentType.environments && this.prevEnvironmentType.environments[0].schemas && this.selectedEnvironment.schemas && this.selectedEnvironment.schemas[$index] && this.selectedEnvironment.schemas[$index].schemaMap) {
            let foundConnection = this.prevEnvironmentType.environments[0].schemas.find(item => item.schemaId == this.selectedEnvironment.schemas[$index].schemaMap.schemaId)
            if (!this.selectedEnvironment.schemas[$index].isSuperUser && foundConnection) {
                return true;
            }
        }
        return false;
    }




    ngOnDestroy(): void { }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotatorItem.ts